// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__tvsFR","featureGroupsContainer":"Overview_featureGroupsContainer__3BTEZ","ideasContainer":"Overview_ideasContainer__29uLX"};